import jsPDF from 'jspdf';

function creaDiplomaPDF(nombreUsuario, imagenCertificado) {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'px',
    format: [1451, 1036] // Establece el tamaño del documento
  });
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  const img = new Image();
  img.src = imagenCertificado;
  img.width = 1451;
  img.height = 1036;
  

  img.onload = function () {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    ctx.font = 'bold 60px "Roboto Regular", sans-serif';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';

    // Ajusta la posición del texto según tus necesidades
    const x = canvas.width / 2;
    const y = 490;

    // Renderiza el nombre del usuario en el certificado
    ctx.fillText(nombreUsuario, x, y);

    // Convierte el canvas a datos de imagen
    const imageData = canvas.toDataURL('image/jpeg', 1.0);
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();

     // Abre la imagen en una nueva pestaña del navegador
     const imageWindow = window.open('', '_blank');
     imageWindow.document.write(`<img src="${imageData}" width="${canvas.width}" height="${canvas.height}" />`);
 

    // Agrega la imagen del certificado con el nombre del usuario al PDF
    pdf.addImage(imageData, 'JPEG', 0, 0, width, height);

    // Descarga el certificado como un archivo PDF
    pdf.save(`reconocimiento-${nombreUsuario}.pdf`);
  };
}

export default creaDiplomaPDF;
